import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Footer from './Footer';
import SEO from './SEO';
import CookiePopup from './CookiePopup';

const Layout = ({
  children,
  title,
  description,
  seoImage,
  lightMode,
  specificUrl
}) => {
  return (
    <>
      <SEO
        title={title}
        description={description}
        image={seoImage}
        specificUrl={specificUrl}
      />
      <Header lightMode={lightMode} />
      <main>{children}</main>
      <CookiePopup />
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
